import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles/snack.module.css';
export const SnackViewContext = /*#__PURE__*/React.createContext({});
/**
 * Компонент `<SnackView />` -  вёрстка уведомления.
 * Стоит использовать если всплывающее уведомление не требуется, а нужна карточка, вставленная в вёрстку страницы.
 */
export const SnackView = /*#__PURE__*/forwardRef(function Snack({
  className,
  header,
  paragraph,
  variant = 'neutral',
  wideButton = false,
  icon,
  closeButton,
  children,
  onClick,
  ...props
}, ref) {
  const hasText = header || paragraph;
  const snackClassName = useMemo(() => clsx(styles.snack, styles[variant], className), [variant, className]);
  const haveChildreen = !!children;
  const haveButtonsInHeader = closeButton || !wideButton && haveChildreen;
  const haveButtonsInFooter = haveChildreen && (wideButton || closeButton);
  return hasText ? (/*#__PURE__*/React.createElement(SnackViewContext.Provider, {
    value: {
      variant
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: snackClassName,
    ref: ref,
    ...props,
    "data-testid": "snack"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.snackHeader
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: styles.textInfo
  }, header && /*#__PURE__*/React.createElement("p", {
    className: styles.header
  }, header), paragraph && /*#__PURE__*/React.createElement("p", {
    className: styles.paragraph
  }, paragraph)), haveButtonsInHeader && /*#__PURE__*/React.createElement("div", {
    className: styles.buttonWrapper
  }, closeButton || children)), haveButtonsInFooter && /*#__PURE__*/React.createElement("div", {
    className: styles.snackFooter
  }, children)))) : null;
});